<template>
  <page :title="title" :breadcrumb="breadcrumb" :load="doInit">
    <message :messages="messages"></message>
    <v-card>
      <v-card-text>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex xs12 lg8>
              <v-layout row wrap>
                <v-flex lg6 xs12 v-if="newRef">
                  <v-text-field label="Referrer Code*" data-vv-as="Referrer Code" v-model="refForm.referrerCode" :error-messages="errors.collect('referrerCode')" v-validate="'required|max:10|param'" data-vv-name="referrerCode"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12 v-else>
                  <v-subheader class="queryLabel">Referrer Code</v-subheader>
                  <div class="title">{{refForm.referrerCode}}</div>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field label="Description*" data-vv-as="Description" v-model="refForm.referrerDesc" :error-messages="errors.collect('referrerDesc')" v-validate="'required|max:100'" data-vv-name="referrerDesc"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-autocomplete :items="b2cKeys" v-model="refForm.b2cKey" label="Default B2C Key" item-text="label" item-value="value" data-vv-name="b2cKey" data-vv-as="Default B2C Key" :error-messages="errors.collect('b2cKey')" clearable></v-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <v-card flat color="grey lighten-3">
                    <v-card-text>
                      <v-subheader>Link example</v-subheader>
                      <v-layout row wrap>
                        <v-flex xs12>
                          <span class="font-weight-medium">Travel:</span>
                          https://{URL}/travel/{ProductCode}/?ref={{refForm.referrerCode}}
                        </v-flex>
                        <v-flex xs12>
                          <span class="font-weight-medium">Fire:</span>
                          https://{URL}/fire/{ProductCode}/?ref={{refForm.referrerCode}}
                        </v-flex>
                        <v-flex xs12>
                          <span class="font-weight-medium">Maid:</span>
                          https://{URL}/domestic-worker/{ProductCode}/?ref={{refForm.referrerCode}}
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" type="submit" :loading="loading" @click.prevent="doValidateForm">
          {{newRef? 'Add Referrer' : 'Update Referrer'}}
          <v-icon right>mdi-content-save</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import MessageMixin from '@/mixins/message'

export default {
  data() {
    return {
      breadcrumb: [],
      newRef: false,
      loading: false,
      refForm: {
        referrerCode: null,
        referrerDesc: null,
        b2cKey: null
      },
      menu: []
    }
  },
  computed: {
    ...mapGetters(['derieveBreadcrumbByName']),
    title() {
      if (this.newRef) {
        return 'New Referrer'
      } else {
        return 'Review Referrer'
      }
    },
    b2cKeys() {
      return this.$store.state.adminB2c.referrers.keys
    }
  },
  methods: {
    async doInit() {
      if (!this.newRef) {
        // Review
        this.reviewRef()
      }
    },
    async reviewRef() {
      try {
        const apiURI = this.$store.state.adminB2c.referrers.menu.getRef
        const expand = {
          id: this.id
        }
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result
        if (data) {
          // ref data init
          this.refForm.referrerCode = data.referrerCode
          this.refForm.referrerDesc = data.referrerDesc
          this.refForm.b2cKey = data.b2cKey

          // Extract menu
          this.menu = extractMenu(data._links)
        }
      } catch (error) {
        throw error
      }
    },
    doValidateForm() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newRef) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.$store.state.adminB2c.referrers.menu.createRef
      if (apiURI) {
        this.loading = true
        try {
          const result = await this.$http.post(apiURI, this.refForm)
          const { data } = result

          if (data) {
            // Show message via notify
            this.notify(data)

            // Redirect back to listing
            this.$router.push({ name: 'referrers' })
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    async doUpdate() {
      if (this.menu.updateRef) {
        this.loading = true
        try {
          const result = await this.$http.post(this.menu.updateRef, this.refForm)
          const { data } = result

          if (data) {
            // Show message
            this.message(data)
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    }
  },
  beforeMount() {
    if (this.id === 'new') {
      this.newRef = true
    }
    // Manual breadcrumb
    this.breadcrumb = this.derieveBreadcrumbByName('referrers')
    this.breadcrumb.push({
      name: 'referrerReview',
      text: this.title
    })
  },
  props: ['id'],
  mixins: [MessageMixin]
}
</script>

<style>
</style>
